import { InputNumber } from "antd";
import styled from "styled-components";

import color from "../_style/color";
import { plusIcon, minusIcon } from "assets/base64icon";

export default styled(InputNumber).attrs({
  formatter: (value) => value.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
  parser: (value) => value.replace(/\s?|(,*)/g, ""),
})`
  margin-left: 30px;
  border-left: 0;
  border-right: 0;
  border-color: ${color.gainsboro} !important;
  box-shadow: unset !important;

  input {
    text-align: center;
  }

  .ant-input-number-handler-wrap {
    opacity: 1;
    display: flex;
    border: unset;
    width: 100%;
    background: unset;
    justify-content: space-between;
  }

  .ant-input-number-handler-up {
    position: absolute;
    line-height: 30px;
    height: 32px;
    width: 30px;
    right: -29px;
    top: -1px;
    border: 1px solid ${color.gainsboro};
    border-left: 0;
    border-radius: 0 2px 2px 0;

    span {
      display: none !important;
    }
    ::before {
      content: url(${plusIcon});
    }
  }

  .ant-input-number-handler-down {
    position: absolute;
    line-height: 30px;
    height: 32px;
    width: 30px;
    left: -29px;
    top: -1px;
    border: 1px solid ${color.gainsboro};
    border-right: 0;
    border-radius: 2px 0 0 2px;

    span {
      display: none !important;
      border: unset;
    }

    ::before {
      content: url(${minusIcon});
    }
  }

  .ant-input-number-handler-up:hover,
  .ant-input-number-handler-down:hover {
    height: 32px !important;
  }

  .ant-input-number-handler,
  .ant-input-number-handler-wrap:hover .ant-input-number-handler {
    background: ${color.aliceBlue};
    height: 32px;
  }
`;
